<template>
  <div>
    <multiselect
      v-model="input"
      :options="options"
      :label="label"
      :trackBy="trackBy"
      :selectLabel="selectLabel"
      :selectedLabel="selectedLabel"
      :deselect-label="deselectLabel"
      :multiple="multiple"
      :placeholder="placeholder"
      :taggable="taggable"
      :tagPlaceholder="tagPlaceholder"
      :clear-on-select="clearOnSelect"
      :close-on-select="closeOnSelect"
      :disabled="disabled"
      @tag="addTag"
      @open="openDropdown()"
      @close="closeDropdown()"
      ref="multiselect"
    >
      <template v-slot:noResult>
        {{ $t('Not found') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('Not found') }}
      </template>
      <template slot="afterList">
        <div v-observe-visibility="reachedEndOfList" />
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: {
    value: {
      type: [String, Number, Array],
      default: () => null
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String
    },
    trackBy: {
      type: String
    },
    selectLabel: {
      type: String
    },
    selectedLabel: {
      type: String
    },
    deselectLabel: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    taggable: {
      type: Boolean,
      default: () => false
    },
    searchable: {
      type: Boolean,
      default: () => false
    },
    tagPlaceholder: {
      type: String,
      default: () => 'Press to enter to confirm'
    },
    allowAddNewTag: {
      type: Boolean,
      default: () => false
    },
    clearOnSelect: {
      type: Boolean,
      default: () => true
    },
    closeOnSelect: {
      type: Boolean,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    search: ''
  }),
  computed: {
    input: {
      get() {
        if (this.multiple) {
          if (this.value && this.value.length && this.options && this.trackBy && this.label) {
            let newArray = []
            for (let i = 0; i < this.value.length; i++) {
              const item = this.value[i]
              const findOption = this.options.find(option => option[this.trackBy] === item)
              if (findOption) {
                newArray.push({ [this.label]: findOption[this.label], [this.trackBy]: item })
              } else {
                newArray.push({ [this.label]: item, [this.trackBy]: item })
              }
            }
            return newArray
          } else if (this.value && this.value.length && this.options) {
            return this.value
          } else {
            return []
          }
        } else {
          if (this.options && this.trackBy && this.label) {
            const findOption = this.options.find(option => option[this.trackBy] === this.value)
            return findOption
              ? findOption
              : { [this.label]: this.value, [this.trackBy]: this.value }
          } else if (this.options) {
            return this.value
          } else {
            return null
          }
        }
      },
      set(value) {
        if (this.multiple) {
          const val =
            value && value.length && this.trackBy
              ? value.map(item => item[this.trackBy])
              : value && value.length
              ? value
              : []
          this.$emit('input', val)
        } else {
          const val = value && this.trackBy ? value[this.trackBy] : value
          this.$emit('input', val)
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.allowAddNewTag) {
        this.initOptions()
      }
      this.defaultOptions = [...this.options]
    })
  },
  methods: {
    initOptions() {
      if (this.multiple && this.value && this.value.length && this.options && this.options.length) {
        if (this.trackBy && this.label) {
          let newArray = []
          for (let i = 0; i < this.value.length; i++) {
            const item = this.value[i]
            const findOption = this.options.find(option => option[this.trackBy] === item)
            if (!findOption) {
              newArray.push({ [this.label]: this.value, [this.trackBy]: item })
            }
          }
          if (newArray.length) {
            this.$emit('update:options', [...this.options, ...newArray])
          }
        } else {
          let newArray = []
          for (let i = 0; i < this.value.length; i++) {
            const item = this.value[i]
            const findOption = this.options.find(option => option === item)
            if (!findOption) {
              newArray.push(item)
            }
          }
          if (newArray.length) {
            this.$emit('update:options', [...this.options, ...newArray])
          }
        }
      } else if (this.value && this.options && this.options.length) {
        if (this.trackBy && this.label) {
          const findOption = this.options.find(option => option[this.trackBy] === this.value)
          if (!findOption) {
            const newOpt = [
              ...this.options,
              { [this.label]: this.value, [this.trackBy]: this.value }
            ]
            this.$emit('update:options', newOpt)
          }
        } else {
          if (!this.options.includes(this.value)) {
            this.$emit('update:options', [...this.options, this.value])
          }
        }
      }
    },
    addTag(e) {
      if (e && this.options && this.allowAddNewTag) {
        if (this.trackBy && this.label) {
          const findOption = this.options.find(option => option[this.trackBy] === e)
          if (!findOption) {
            const newOpt = [...this.options, { [this.label]: e, [this.trackBy]: e }]
            this.$emit('update:options', newOpt)
          }
        } else {
          if (!this.options.includes(e)) this.$emit('update:options', [...this.options, e])
        }
      }
      this.$emit('tag', e)
    },
    openDropdown() {
      if (this.multiple && this.value && this.options && this.options.length) {
      } else if (this.value && this.options && this.options.length) {
        if (this.trackBy && this.label) {
          const findOption = this.options.find(option => option[this.trackBy] === this.value)
          if (findOption) {
            this.search = findOption[this.label]
          } else {
            if (!this.allowAddNewTag) {
              const newOpt = [
                ...this.options,
                { [this.label]: this.value, [this.trackBy]: this.value }
              ]
              this.$emit('update:options', newOpt)
            }
            this.search = this.value
          }
        } else {
          if (this.options.includes(this.value)) {
            this.search = this.value
          } else {
            if (!this.allowAddNewTag) {
              this.$emit('update:options', [...this.options, this.value])
            }
          }
        }
      }
      const multiselect = this.$refs.multiselect
      if (multiselect && this.search) {
        multiselect.updateSearch(this.search)
      }
    },
    closeDropdown() {
      this.search = ''
      if (!this.allowAddNewTag) {
        this.$emit('update:options', [...this.defaultOptions])
      }
    },
    reachedEndOfList(reached) {
      if (reached) {
        this.$emit('scroll:end', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MultiSelectCustom.vue